/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "내 개인정보를 판매하거나 공유하지 않음",
      "Bumble Date",
      "당사 앱들",
      "소개",
      "인재채용",
      "문의하기",
      "투자자",
      "상점",
      "회사소개",
      "앱 다운로드하기",
      "Bumble 에서의 접근성",
      "가이드라인",
      "쿠키 관리",
      "현대 노예제 방지법",
      "수집 시 통지",
      "개인정보 취급방침",
      "이용약관",
      "법무",
      "Washington 소비자 건강 개인정보 취급방침",
      "QR 코드를 스캔해서 Bumble 앱을 다운로드하세요",
      "이곳에서 계약을 종료하세요",
      "메뉴 닫기",
      "메뉴 열기",
      "언어 옵션",
      "꼬리말",
      "Bumble 에서의 접근성",
      "Apple 및 Apple 로고는 Apple Inc.의 등록 상표입니다.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "인재채용",
      "Google Play는 Google LLC의 상표입니다.",
      "가이드라인",
      "투자자",
      "쿠키 관리",
      "현대판 노예 방지 성명",
      "수집 시 통지",
      "개인정보 취급방침",
      "시즌 별 데이트 가이드",
      "이용약관",
      "앱",
      "Washington 소비자 건강 데이터 개인 정보 보호 정책",
      "소개",
      "앰배서더",
      "커뮤니티를 찾고 새로운 친구를 만드세요",
      "전문적으로 네트워크를 구축하고 경력을 쌓으세요",
      "진지한 관계, 캐주얼한 관계 또는 그 사이에 있는 것을 찾으세요",
      "The Buzz",
      "더 알아보기",
      "트래블 모드로{{__EOL__}}전세계와 연결되세요",
      "데이트",
      "기능들",
      "Compliments™",
      "Compliments를 보내서 사람들 속에서 돋보이세요.",
      "발견",
      "하루에 한 번씩 업데이트되는 맞춤형 페이지, 회원님과 가장 잘 맞을 것 같은 사람들을 하이라이트합니다.",
      "투명 회원 모드",
      "투명 회원 모드를 사용해서 전 연인, 친척, 직장 상사로부터 프로필을 숨기세요.",
      "바로 짝되기",
      "Bumble IRL 이벤트에서 대화를 시작하셨나요? 앱에서 계속 이어가세요.",
      "Opening Moves",
      "Opening Moves를 선택하면 내가 먼저 대화를 시작할 필요 없이 짝들이 인사를 건네도록 초대할 수 있어요.",
      "스누즈 모드",
      "스누즈 모드로 데이팅을 일시정지하세요. 다시 데이트할 준비가 되면, 언제든지 돌아오세요.",
      "SuperSwipe",
      "상대방의 프로필 분위기가 합격이라구요? SuperSwipe로 마음을 전하세요.",
      "트래블 모드",
      "트래블 모드로 전 세계 어느 곳에서 짝이 될 수 있어요.",
      "영상 채팅",
      "영상 채팅과 음성 통화를 사용해서 실제로 만날 준비가 됐는지 확인해보세요.",
      "웹 앱",
      "Bumble 경험을 브라우저에서 직접 즐기세요.",
      "Bumble 앱을 다운로드하세요",
      "BFF",
      "안전",
      "스토리",
      "지원",
      "상점",
      "메인",
      "Compliments를 보내서 많은 사람들 속에서 기억에 남는 사람이 되세요.",
      "Compliments",
      "진솔하고 서로 존중하는 의미 있는 연결을 만들기 위해 설계된 기능입니다.",
      "전 연인, 친척, 직장 상사로부터 프로필을 숨기세요.",
      "투명 회원 모드",
      "스누즈 모드로 데이팅을 일시정지하세요.",
      "스누즈 모드",
      "마음에 드는 사람을 보셨나요? 상대방에게 알려주세요.",
      "SuperSwipe",
      "데이트 탐색하기",
      "최애 면세점 과자와 짝을 전세계에서 어디서나 찾아보세요.",
      "트래블 모드",
      "굳이 외출할 필요 없이 오프라인 만남과 비슷한 경험을 쌓으세요.",
      "영상 통화",
      "우리의 리더들은 Bumble 의 가치를 국가 곳곳에 있는 커뮤니티에 도입하는 데 도움을 줍니다.",
      "커뮤니티 리더들",
      "회원님의 사람들을 찾고 관심사를 통해 친해지는 데에 도움이 되도록 디자인 되었어요.",
      "그룹 모임을 계획하거나, 근처에서 일어나는 있는 지역 이벤트를 발견해보세요.",
      "Plans",
      "BFF 둘러보기",
      "회원님께서 사랑과 친구를 찾는 것을 돕기 위해 필요한 모든 가이드와 영감이에요.",
      "내가 원하는 우정을 쌓는 데에 도움이 되는 조언과 이야기들이에요.",
      "우정 허브",
      "도쿄에서 토론토까지, Bumble 전 세계에서 발견한 사랑을 확인해보세요.",
      "사랑 이야기",
      "완벽한 데이트를 계획하세요—어디서, 언제, 누구와도 상관없이요.",
      "시즌 별 데이트 가이드",
      "이야기 살펴보기",
      "더 읽기",
      "{{social_network}} 에서의 Bumble",
      "문의하기",
      "로그인하기",
      "(opens in new window)",
      "자주 하는 질문",
      "Cookie Policy",
      "Bumble - The Blog",
      "인재 채용",
      "채팅",
      "시",
      "쿠키 관리",
      "Copyright © 2006 – present. Bumble. All rights reserved.",
      "자신 있는 데이트를 위한 보고서",
      "Apple 및 Apple 로고는 Apple의 등록 상표입니다.{{__EOL__}}Google Play(은)는 Google LLC의 상표입니다.",
      "다운로드하세요",
      "Facebook",
      "팔로우하세요",
      "도움말 센터",
      "Instagram",
      "언어",
      "LinkedIn",
      "Bumble는 Bumble Inc의 일부입니다.",
      "개인정보 취급방침",
      "Safety Centre",
      "사이트맵",
      "현대판 노예제 방지 성명",
      "이용약관",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "일"
            ],
            "singular": [
                  "일"
            ]
      },
      "hour": {
            "plural": [
                  "시간"
            ],
            "singular": [
                  "시간"
            ]
      },
      "minute": {
            "plural": [
                  "분"
            ],
            "singular": [
                  "분"
            ]
      },
      "month": {
            "plural": [
                  "개월"
            ],
            "singular": [
                  "개월"
            ]
      },
      "second": {
            "plural": [
                  "초"
            ],
            "singular": [
                  "초"
            ]
      },
      "year": {
            "plural": [
                  "년"
            ],
            "singular": [
                  "년"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
